
import React, { useState, useEffect, Children, cloneElement  } from 'react';
import './index.less'
import Header from 'components/Header';
import Footer from 'components/Footer';
import { request, } from "utils.js";
import axios from 'axios';
export default function PageBox(props) {
  let { useBanner } = props;
  let [ user , setUser ] = useState('')
  let [ tenantUser , setTenantUser ] = useState({})
  useEffect(() => {
    if(user)  return;
		axios({
			method: "get",
			url: "/aiprt-basedata-register-be/register/user/info",
		}).then((res) => {
      const { data } = res;
      if(res.status === 200){
        if(data.code === "200") {
          setUser(data?.data?.username);
          setTenantUser(data?.data);
        }
      }
		}).catch(err => {
      setUser('');
    });
    let afterLogin = sessionStorage.getItem('afterLogin')
    if(afterLogin) {
      location.href = afterLogin;
      sessionStorage.removeItem('afterLogin')
    }
	}, []);

  return (
    <div className="pagebox">
      <Header user={user} />
      <div className={`context ${useBanner ? '' : 'box context-margin'}`}>
        {
          Children.map(props.children, (child, index) =>{
            return cloneElement( child, {
              key: index,
              user,
              tenantUser
            });
          })
        }
      </div>
      <Footer />
    </div>
  );
}
